import SiafLiteApiRepository from "../../external/siafLiteApi";

class OrigemMercadoriaService {
  constructor() {
    this.urlBase = "/estoque/origens-mercadorias";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }
}

export default OrigemMercadoriaService;
